export const defaultValues = {
  total_monthly_expenses: 10000,
  nett_income: 120000,
  gross_income: 150000,
};
